module.exports = __webpack_public_path__ + "img/icon_e51.c57ea663.png";